import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import {
  DropdownMenuItem,
  DropdownMenuLabel,
} from '@savgroup-front-common/primitive/ui/dropdown-menu';

import { MenuRowContent } from '../../MenuRowContent/MenuRowContent';
import { CREATE_MENU_ITEM_TYPE, CreateMenuItem } from '../CreateButton.types';

interface CreateButtonMenuItemProps {
  item: CreateMenuItem;
}

export const CreateButtonMenuItem: FunctionComponent<
  CreateButtonMenuItemProps
> = ({ item }) => {
  if (item.type === CREATE_MENU_ITEM_TYPE.TITLE) {
    return (
      <DropdownMenuLabel key={item.key}>
        <SafeFormattedMessageWithoutSpread message={item.label} />
      </DropdownMenuLabel>
    );
  }

  if (item.type === CREATE_MENU_ITEM_TYPE.LINK) {
    return (
      <DropdownMenuItem
        key={item.key}
        asChild
        disabled={item.isDisabled}
        data-testid={`menu_${item.key}`}
      >
        <Link to={item.href ?? '#'}>
          <MenuRowContent icon={item.icon}>
            <SafeFormattedMessageWithoutSpread message={item.label} />
          </MenuRowContent>
        </Link>
      </DropdownMenuItem>
    );
  }

  if (item.type === CREATE_MENU_ITEM_TYPE.BUTTON) {
    return (
      <DropdownMenuItem
        key={item.key}
        disabled={item.isDisabled}
        data-testid={`menu_${item.key}`}
        onSelect={(event) =>
          item.onClick(
            item,
            event as unknown as React.MouseEvent<HTMLButtonElement, MouseEvent>,
          )
        }
      >
        <MenuRowContent icon={item.icon}>
          <SafeFormattedMessageWithoutSpread message={item.label} />
        </MenuRowContent>
      </DropdownMenuItem>
    );
  }

  return null;
};
